import styled from 'styled-components';
import { Color, MaxWidth } from '../../base';

const HeroLandingWrapper = styled.div`
  background-color: ${Color.redLight};
  padding: 160px 0;
  text-align: center;
  position: relative;
  ${MaxWidth.md`
    padding-top: 80px;
    padding-bottom: 320px;
  `}
  ${MaxWidth.sm`
    padding-top: 80px;
    padding-bottom: 200px;
  `}
  h1 {
    font-size: 60px;
    ${MaxWidth.sm`
      font-size: 32px;
    `}
  }
`;

const HeroLandingImage = styled.div`
  position: absolute;
  bottom: -6px;
  left: 0;
  width: 100%;
  img { width: 100%; }
  ${MaxWidth.md`
    display: none;
  `}
`;

const HeroLandingImageMobile = styled.div`
  display: none;
  ${MaxWidth.md`
    img { width: 100%; }
    display: block;
    position: absolute;
    bottom: -6px;
    left: 0;
    width: 100%;
  `}
`;

export { HeroLandingWrapper, HeroLandingImage, HeroLandingImageMobile };
